import { getConfig } from './config';

const apis = {};

export function setAPIs (endpoints) {
  Object.assign(apis, endpoints);
}

export function getAPI (options = {}) {
  let mapping = apis[options.name];
  if (mapping === undefined)
  {
    throw new Error('could not find API url mapping by name: ' + options.name);
  }

  // prepend the API root location and remove any double slashes that may have occurred after joining them
  let path = mapping.path;
  path = getConfig('apiRoot') + path;
  path = path.replace(/[^:]\/\//g, '/');

  // substitute in the path parameters
  if (options.params !== undefined)
  {
    for (const param in options.params)
    {
      path = path.replace(':' + param, encodeURIComponent(options.params[param]));
    }
  }

  // add in any predefined/static query string params with any customizations merged on top
  let queryString = '';

  let mappingQuery = mapping.query !== undefined ? mapping.query : {};
  let optionsQuery = options.query !== undefined ? options.query : {};
  let combinedQuery = Object.assign({}, mappingQuery, optionsQuery);

  for (const name in combinedQuery)
  {
    if (queryString !== '')
    {
      queryString += '&';
    }

    let value = combinedQuery[name];
    if (Array.isArray(value))
    {
      value.forEach((v, i) => {
        queryString += encodeURIComponent(name) + '=' + encodeURIComponent(v);

        if (i < value.length - 1)
        {
          queryString += '&';
        }
      });
    }
    else
    {
      queryString += encodeURIComponent(name) + '=' + encodeURIComponent(combinedQuery[name]);
    }
  }

  // finally, append the computed query string value
  if (queryString !== '')
  {
    path += '?' + queryString;
  }

  return path;
}